import '../scss/app.scss'; // Importing SCSS file

document.addEventListener('DOMContentLoaded', () => {
    const { image, text: html, network } = KOCNetworkPopupData;
    let url = image.url;
    let arrow_svg = `<svg fill="#000000" width="50px" height="50px" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" id="arrow">
      <path d="M8.29289 2.29289C8.68342 1.90237 9.31658 1.90237 9.70711 2.29289L14.2071 6.79289C14.5976 7.18342 14.5976 7.81658 14.2071 8.20711L9.70711 12.7071C9.31658 13.0976 8.68342 13.0976 8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L11 8.5H1.5C0.947715 8.5 0.5 8.05228 0.5 7.5C0.5 6.94772 0.947715 6.5 1.5 6.5H11L8.29289 3.70711C7.90237 3.31658 7.90237 2.68342 8.29289 2.29289Z"/>
    </svg>`;

    let kocoOrthoImage = "http://www.kocortho.com/wp-content/uploads/2025/01/KOC-Popup-Image.png";

    let popup = document.createElement('div');
    popup.classList.add('koc-network-popup');

    // Check if the popup has been shown for the current network in the last 72 hours
  
        popup.innerHTML = `
        <div class="koc-network-popup__overlay">
            <div class="koc-network-popup__content">
             <div class="close-button-container"> <button class="popup-close">Close</button></div>
            
                 <div class="popup-image-container">
                   <img src="${url}" alt="Network Image" class="popup-image">
                 
                    <div class="arrow-container">${arrow_svg}</div>
                       <img src="${kocoOrthoImage}" alt="KOC Ortho Image" class="popup-image">
                  
                </div>
                   
                <p>${html}</p>
               
           
             
            </div>
        </div>`;

        // Add event listener for the close button to hide the popup and set the 72-hour timer
        popup.querySelector('.popup-close').addEventListener('click', () => {
            // Store that the popup was closed for this network
            localStorage.setItem(`popup-shown-${network}`, Date.now());
            popup.classList.add('fade-out');
            setTimeout(() => popup.remove(), 500); // Wait for fade-out animation to finish
        });

        // Fade in the popup
        document.body.appendChild(popup);
        setTimeout(() => popup.classList.add('fade-in'), 50);
  
});
